// https://github.com/egonolieux/bootstrap-imageupload

import getAlertHtml from '@newswebsiteapp/shared/lib/getAlertHtml'

import { isValidImageFile } from './pure'

const defaultOptions = {
  allowedFormats: ['jpg', 'jpeg', 'png', 'gif'],
  maxFileSizeKb: 2048,
}

export default function ($imageupload, givenOptions = {}) {
  const options = $.extend({}, defaultOptions, givenOptions)

  const $fileInput = $imageupload.find('[data-file-input]').expectLength()
  const $imagePreview = $imageupload.find('.thumbnail').expectLength()
  const $removeFileButton = $imageupload
    .find('[data-remove-file-button]')
    .expectLength()
  const $browseFileButton = $imageupload
    .find('[data-browse-file-button]')
    .expectLength()
  const $browseFileButtonSpan = $browseFileButton.find('span').expectLength()
  const $defaultProfilePicture = $imageupload
    .find('.default-profile-picture')
    .expectLength()

  // Unbind all previous bound event handlers.
  $fileInput.off()
  $removeFileButton.off()

  $removeFileButton.on('click', () => {
    $removeFileButton.blur()

    $imageupload.find('.alert').remove()
    $imagePreview.addClass('hidden')
    $browseFileButtonSpan.text('Browse')
    $removeFileButton.addClass('hidden')
    $fileInput.val('')
    $browseFileButton.removeClass('disabled')
    $defaultProfilePicture.removeClass('hidden')
  })

  $fileInput.on('change', () => {
    $fileInput.blur()

    // Check if file is uploaded.
    if (!($fileInput[0].files && $fileInput[0].files[0])) {
      return
    }

    const file = $fileInput[0].files[0]

    isValidImageFile(options, file, (isValid, message) => {
      if (isValid) {
        const fileReader = new FileReader()

        fileReader.onload = function (e) {
          // Show thumbnail and remove button.
          $imageupload.find('.alert').remove()
          $imagePreview.attr('src', e.target.result)
          $imagePreview.removeClass('hidden')
          $browseFileButton.find('span').text('Change')
          $removeFileButton.removeClass('hidden')
          $defaultProfilePicture.addClass('hidden')
        }

        fileReader.onerror = function () {
          $imageupload.prepend(getAlertHtml('Error loading image file.'))
          $fileInput.val('')
        }

        fileReader.readAsDataURL(file)
      } else {
        $imageupload.prepend(getAlertHtml(message))
        $browseFileButton.find('span').text('Browse')
        $fileInput.val('')
      }
    })
  })
}
